import noteContext from "./noteContext";
import { useState } from "react";

const NoteState = (props) => {
  const host = "https://notebooks-react-app.herokuapp.com"
  // hardcode for a moment
  const notesInitial = []
  const [notes, setNotes] = useState(notesInitial);

  //   GET all notes
  const getNotes = async () => {
     // API CALL
     const response = await fetch(`${host}/api/notes/fetchallnotes`, {
      method: 'GET', 
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },
    });
    const json = await response.json() 
    // console.log(json)
    setNotes(json)
  };

  //   Add a note
  const addNote = async (title, description, tag) => {
     // API CALL
     const response = await fetch(`${host}/api/notes/addnote/`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },
      body: JSON.stringify({title, description, tag})
    });

    const note = await response.json()
    setNotes(notes.concat(note));
    // console.log(json)

    // console.log("Adding a new note");
    // const note = {
    //   title: title,
    //   description: description,
    //   tag: tag,
    // };
  };

  //   DELETE a note
  const deleteNote = async (id) => {
    // API CALL
    const response = await fetch(`${host}/api/notes/deletenote/${id}`, {
      method: 'DELETE', 
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },
      body: JSON.stringify()
    });
    const json = await response.json(); 
    // console.log(json)

    // console.log("Deleting note" + id);
    const newNotes = notes.filter((note) => {
      return note._id !== id;
    });
    setNotes(newNotes);
  };

  //   EDIT a note
  const editNote = async (id,title,description,tag) => {
    // API CALL
    const response = await fetch(`${host}/api/notes/updatenote/${id}`, {
      method: 'PUT', 
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },
      body: JSON.stringify({title, description, tag})
    });
    const json =  await response.json(); 
    // console.log(json)

    let newNotes = JSON.parse(JSON.stringify(notes))
    // logic to edit in client
    for (let index = 0; index < newNotes.length; index++) {
      const element = newNotes[index];
      if(element._id===id){
        newNotes[index].title = title;
        newNotes[index].description = description;
        newNotes[index].tag = tag;
        break;
      }
    }
    setNotes(newNotes);
  };

  return (
    <noteContext.Provider
      value={{ notes, setNotes, addNote, editNote, deleteNote, getNotes }}
    >
      {props.children}
    </noteContext.Provider>
  );
};

export default NoteState;
